import React from 'react';
import { Tooltip } from 'antd';

type Props = {
  label: string;
  value: React.ReactNode;
  valueClass?: string;
  sub?: React.ReactNode;
  tooltip?: string;
};

/** Compact metric tile (Card+Statistic pattern, sized for dense grids). */
const KpiTile: React.FC<Props> = ({
  label,
  value,
  valueClass,
  sub,
  tooltip,
}) => {
  const labelEl = tooltip ? (
    <Tooltip title={tooltip}>
      <span className="studio2__tile-label">{label}</span>
    </Tooltip>
  ) : (
    <span className="studio2__tile-label">{label}</span>
  );
  return (
    <div className="studio2__tile">
      {labelEl}
      <span className={`studio2__tile-value ${valueClass ?? ''}`}>{value}</span>
      {sub != null && <span className="studio2__tile-sub">{sub}</span>}
    </div>
  );
};

export default KpiTile;
